/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';

export const Container = styled.section`
  padding: 30px;
  margin: 50px auto;
  height: 100%;

  span{
    display: block;
    margin-top: 16px;
  }
  
  @media ${device.tablet} {
    padding: 0;
    max-width: 1300px;
    width: calc(100% - 150px);
    margin: 60px auto 150px;
  }
}`;

export const Title = styled(Text).attrs({
  as: 'h3',
  family: 'bold',
})<{ mb: number }>`
  font-size: 24px;
  margin-bottom: ${(props) => (props.mb ? props.mb : '20px')};

  @media ${device.mobileS} {
    font-size: 18px;
  }

  @media ${device.tablet} {
    font-size: 24px;
  }
`;

export const MiniTitle = styled(Text).attrs({
  as: 'h3',
  family: 'bold',
})`
  font-size: 20px;
  margin-bottom: 20px;

  @media ${device.mobileS} {
    font-size: 16px;
  }

  @media ${device.tablet} {
    font-size: 20px;
  }
`;

export const TataKelolaHeader = styled.div`
  position: relative;
  margin-top: 110px;

  img {
    width: 100%;
  }
`;

export const ImageTitle = styled(Text).attrs({ as: 'h3', weight: 'bold' })`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  @media ${device.mobileS} {
    font-size: 20px;
  }

  @media ${device.tablet} {
    font-size: 40px;
  }
`;

export const Item = styled(Flex)`
  flex-direction: column;
`;

export const Paragraph = styled(Text).attrs({
  as: 'p',
  size: '18px',
  align: 'justify',
})<{ mb: number }>`
  margin-bottom: ${(props) => (props.mb ? props.mb : '50px')};
  line-height: 1.5;
`;

export const UnorderList = styled.ul`
  padding-left: 30px;
  padding-top: 16px;
  margin-bottom: 16px;
`;

export const WhistleContainer = styled(Flex)`
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 14px 32px;
  align-items: center;

  @media ${device.tablet} {
    width: 620px;
  }
`;

export const WhistleText = styled(Flex)`
  flex-direction: column;
  margin-left: 32px;
`;

export const DownloadContainer = styled(Flex)`
  margin-top: 50px;

  @media ${device.mobileS} {
    flex-direction: column;
  }

  @media ${device.tablet} {
    flex-direction: row;
  }
`;

export const DownloadButton = styled.a`
  display: flex;
  align-items: flex-start;
  color: #969696;
  border: 1px solid #969696;
  border-radius: 6px;
  padding: 14px 20px;
  font-weight: bold;

  &:first-of-type {
    margin-right: 25px;
  }

  @media ${device.mobileS} {
    &:first-of-type {
      margin-bottom: 25px;
    }
  }

  @media ${device.tablet} {
    &:first-of-type {
      margin-bottom: 0;
    }
  }

  &:hover {
    color: #969696;
  }

  img {
    margin-right: 10px;
  }
`;
